/**
 * No-op stub for @datadog/browser-rum in Salesforce widget bundles.
 * Real Datadog RUM patches window.onunhandledrejection, which Lightning Web
 * Security blocks and aborts the widget IIFE before window.wa is published.
 */

type RumInitConfiguration = Record<string, unknown>;

export const datadogRum = {
  init(_config?: RumInitConfiguration): void {
    // intentionally empty
  },
  getInitConfiguration(): RumInitConfiguration | undefined {
    return undefined;
  },
  addError(_error: unknown, _context?: Record<string, unknown>): void {
    // intentionally empty
  },
};
